import React, { useRef, useEffect } from 'react'
import ReactEChartsCore from 'echarts-for-react/lib/core'
import * as echarts from 'echarts/core'
import { RadarChart } from 'echarts/charts'
import {
  GridComponent,
  TitleComponent,
  TooltipComponent,
  RadarComponent,
  GraphicComponent,
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import { RadarContainer } from './Radar.styles'
import { RadarProps } from './Radar.types'

echarts.use([
  RadarChart,
  GridComponent,
  TitleComponent,
  TooltipComponent,
  RadarComponent,
  GraphicComponent,
  CanvasRenderer,
])

export const Radar: React.FC<RadarProps> = ({
  indicators,
  values,
  centerValue,
  color = '#4A5BF6',
  size = 200,
  className,
}) => {
  const chartRef = useRef<ReactEChartsCore>(null)

  const option: echarts.EChartsCoreOption = {
    radar: {
      indicator: indicators,
      shape: 'polygon',
      splitNumber: 5,
      center: ['50%', '50%'],
      radius: '70%',
      axisName: {
        color: '#999999',
        fontSize: 8,
        fontFamily: 'Poppins, Inter, sans-serif',
      },
      splitLine: {
        lineStyle: {
          color: '#E5E5E5',
          width: 1,
        },
      },
      splitArea: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: '#E5E5E5',
          width: 1,
        },
      },
    },
    series: [
      {
        type: 'radar',
        data: [
          {
            value: values,
            areaStyle: {
              color: color,
            },
            lineStyle: {
              color: color,
              width: 2,
            },
            itemStyle: {
              color: color,
              borderWidth: 0,
            },
          },
        ],
        symbol: 'none',
      },
    ],
    graphic:
      centerValue !== undefined
        ? [
            {
              type: 'text',
              left: 'center',
              top: 'center',
              z: 100,
              style: {
                text: centerValue.toString(),
                font: '600 14px Poppins',
                fill: '#1A1A1A',
                align: 'center',
                verticalAlign: 'middle',
              },
            },
          ]
        : [],
  }

  useEffect(() => {
    if (chartRef.current) {
      const instance = chartRef.current.getEchartsInstance()
      instance.resize()
    }
  }, [size])

  return (
    <RadarContainer size={size} className={className}>
      <ReactEChartsCore
        ref={chartRef}
        echarts={echarts}
        option={option}
        notMerge={true}
        lazyUpdate={true}
        style={{ height: '100%', width: '100%' }}
      />
    </RadarContainer>
  )
}
